// src/pages/gt3x/Penalties.jsx
import { useEffect, useState } from "react";
import { fetchSheetViaProxy } from "../../lib/sheets";

const RANGE = "Strafpunktekonto!A1:Q400";

export default function Penalties() {
    const [header, setHeader] = useState([]);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        (async () => {
            try {
                const res = await fetchSheetViaProxy({ range: RANGE });

                let h = [];
                let r = [];

                if (Array.isArray(res?.header) && Array.isArray(res?.rows)) {
                    h = res.header;
                    if (Array.isArray(res.rows[0])) {
                        r = res.rows;
                    } else {
                        r = res.rows.map((obj) => h.map((col) => obj[col]));
                    }
                } else if (Array.isArray(res?.values) && res.values.length > 0) {
                    h = res.values[0];
                    r = res.values.slice(1);
                }

                setHeader(h);
                setRows(r);
            } catch (err) {
                setError(err?.message || String(err));
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    return (
        <>
            <div className="card">
                <h2>Strafpunkte – GT3 Xperience</h2>
                <p className="muted">Hier findet ihr eine Übersicht der aktuellen Strafpunkteverteilung. <br/>
                    Nach dem die Reko die Vorfälle gesichtet hat, werden diese hier automatisiert eingetragen.</p>
            </div>

            {loading && (
                <div className="card">
                    <p>Lade Strafpunkte…</p>
                </div>
            )}

            {error && (
                <div className="card">
                    <p style={{ color: "#ff6b6b" }}>
                        Fehler beim Laden: {error}
                    </p>
                </div>
            )}

            {!loading && !error && (
                <div className="fancyTable">
                    <table className="tbl tbl-body-everett">
                        <thead>
                        <tr>
                            {header.map((h, i) => (
                                <th key={i}>{h}</th>
                            ))}
                        </tr>
                        </thead>

                        <tbody>
                        {rows.length > 0 ? (
                            rows.map((row, ri) => (
                                <tr key={ri}>
                                    {row.map((cell, ci) => {
                                        const raw = cell ?? "";
                                        const num = Number(raw);
                                        const isNumeric = !isNaN(num) && raw !== "";

                                        // Alignment
                                        let textAlign = "center";
                                        if (ci === 0) textAlign = "left";     // A
                                        else if (ci === 16) textAlign = "right"; // Q

                                        // COLOR RULES
                                        let color;

                                        // Spalte C = Index 2
                                        if (ci === 2 && isNumeric) {
                                            if (num >= 0 && num <= 4) color = "#69fb90";
                                            else if (num >= 5 && num <= 6) color = "var(--accent, #e4fe3c)";
                                            else if (num >= 7 && num <= 9) color = "#ffb347";
                                            else if (num >= 10) color = "#ff8c8c";
                                        }

                                        // Spalten D–O: Index 3..14
                                        if (ci >= 3 && ci <= 14 && isNumeric) {
                                            if (num > 0) color = "#ff8c8c";
                                            else if (num < 0) color = "#69fb90";
                                        }

                                        // Spalte P = Index 15
                                        if (ci === 15 && isNumeric) {
                                            if (num >= 10) color = "#ff8c8c";
                                            else if (num > 0) color = "var(--accent, #e4fe3c)";
                                        }

                                        // Spalte Q = Index 16 → immer rot, wenn etwas drinsteht
                                        if (ci === 16 && String(raw).trim() !== "") {
                                            color = "#ff8c8c";
                                        }

                                        const style = {
                                            textAlign,
                                            color,
                                        };

                                        return (
                                            <td key={ci} className={isNumeric ? "num" : ""} style={style}>
                                                {raw}
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={header.length} className="align-left text-dim">
                                    Noch keine Einträge vorhanden.
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
            )}
        </>
    );
}
